// The id of the Score Spec route's single page heading.
//
// It lives here rather than in the page because the EDITOR renders the heading on the editor
// routes — only the editor knows whether this is a new draft, a named draft, or a frozen record —
// while the page owns the focus-on-navigation effect that looks the element up. Both sides need
// the same string, and the page already imports from this feature, so a constant in the feature is
// the direction that does not create a cycle.
export const SCORE_SPEC_HEADING_ID = 'score-spec-heading';
